import React from 'react';
import { Heart } from 'lucide-react';
export function EmotionalClose() {
  return <section className="py-24 px-6 lg:px-8 bg-charcoal text-white text-center" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <Heart className="w-12 h-12 text-warm mx-auto mb-8" data-id="element-52" />
        <h2 className="text-4xl md:text-5xl font-bold text-softblue mb-8 leading-tight" data-id="element-53">
          Una comunidad informada es una comunidad más fuerte.
        </h2>

        <p className="text-xl text-softblue-dark mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-54">
          Cuando los vecinos saben dónde encontrar información, cómo reportar
          problemas y cómo participar, el vecindario se vuelve más conectado.
        </p>

        <div className="bg-charcoal-light/30 p-8 rounded-2xl border border-charcoal-light inline-block mb-12" data-id="element-55">
          <p className="text-2xl font-bold text-warm mb-2" data-id="element-56">Tu voz importa.</p>
          <p className="text-2xl font-bold text-warm mb-2" data-id="element-57">
            Tu experiencia importa.
          </p>
          <p className="text-2xl font-bold text-warm" data-id="element-58">
            Tu participación importa.
          </p>
        </div>

        <div className="space-y-6 text-lg text-softblue-dark max-w-2xl mx-auto" data-id="element-59">
          <p className="font-bold text-xl text-white" data-id="element-60">
            No tienes que hacer todo.
          </p>
          <p data-id="element-61">Solo empieza con una acción.</p>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mt-6 text-sm md:text-base" data-id="element-62">
            <span className="bg-charcoal-light px-4 py-2 rounded-full" data-id="element-63">
              Revisa la próxima reunión.
            </span>
            <span className="bg-charcoal-light px-4 py-2 rounded-full" data-id="element-64">
              Reporta un problema.
            </span>
            <span className="bg-charcoal-light px-4 py-2 rounded-full" data-id="element-65">
              Suscríbete a las alertas.
            </span>
            <span className="bg-charcoal-light px-4 py-2 rounded-full" data-id="element-66">
              Contacta al comité.
            </span>
            <span className="bg-charcoal-light px-4 py-2 rounded-full" data-id="element-67">
              Comparte esta página.
            </span>
          </div>
        </div>

        <p className="text-2xl font-bold text-softblue mt-16" data-id="element-68">
          La comunidad mejora cuando más personas participan.
        </p>
      </div>
    </section>;
}